export enum SupportMaintenanceCostResponsibility {
  REQUESTORS_ORGANIZATION = "Requestor's Organization Responsible",
  PRODUCT_PLATFORM_TEAM_COVERED = 'Product/Platform Team Covered',
  SHARED_RESPONSIBILITY = 'Shared Responsibility',
  NOT_APPLICABLE = 'Not Applicable',
  OTHER = 'Other',
}
